import { Media } from ".";
import Model from "./Model";
import { Position } from "./Position";

export default class ScoutingMedium extends Model {
  static type = "scoutingMedium";

  scoutingId?: string;
  mediumId?: string;
  audience!: number;
  dispersion!: number;
  coverage!: number;
  budget!: string;
  medium!: Media;
  sourceableType!: string;
  sourceableId!: string;
  quantity!: number;
}
